module.exports = __webpack_public_path__ + "static/img/M-6.6e76831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/M-6.png
// module id = 5PpL
// module chunks = 0